// Order here is the order shown in the "Customize Sidebar" picker (enabled first, then hidden).
// The sidebar itself renders enabled items in NAV_ITEMS order, not this order.
export const WORKSPACE_ITEMS = [
  { path: "/", description: "Live pipeline stats and nurture activity feed", defaultEnabled: true },
  { path: "/lead-intake", description: "MQL scoring queue and sequence routing", defaultEnabled: true },
  { path: "/sequence-builder", description: "Multi-channel cadence configuration", defaultEnabled: true },
  { path: "/orchestration", description: "Five-agent real-time handoff visualization", defaultEnabled: true },
  { path: "/velocity-engine", description: "Per-lead conversion probability scores", defaultEnabled: true },
  { path: "/voice-agent", description: "Live Vapi call monitor and voicemail feed", defaultEnabled: false },
  { path: "/email-sms", description: "Make.com sequence runner and message previews", defaultEnabled: false },
  { path: "/pipeline", description: "Full MQL → SQL → demo booked kanban", defaultEnabled: false },
  { path: "/growth-intel", description: "Ranked next-build automation roadmap", defaultEnabled: false },
];

export const DEFAULT_ENABLED_PATHS = WORKSPACE_ITEMS.filter((i) => i.defaultEnabled).map((i) => i.path);
